
































































import vue from 'vue';

// Components
import Button from '~/components/builders/Base/Button.vue';
import Checkbox from '~/components/builders/Base/Checkbox.vue';

// Utils
import UserConsentContext, { CONSENT_OPTIONS } from '~/services/UserConsentContext';

export default vue.extend({
    name: 'Consent',
    components: { Button, Checkbox },
    data: () => ({
        isAnalyticsToggle:
            UserConsentContext.hasAnswered() &&
            UserConsentContext.getOption(CONSENT_OPTIONS.ANALYTICS),
    }),
    methods: {
        cancel() {
            // @ts-ignore
            this.$interfaces.dialogModal.getState().resolver.rej();
        },
        accept() {
            UserConsentContext.acceptUserConsent(this.isAnalyticsToggle);
            // @ts-ignore
            this.$interfaces.dialogModal.getState().resolver.res();
        },
        acceptAll() {
            // @ts-ignore
            UserConsentContext.acceptAll();
            // @ts-ignore
            this.$interfaces.dialogModal.getState().resolver.res();
        },
    },
});
